import { io } from 'socket.io-client';
import { notifyMessage } from './pages/chat/messageBus';
import { notifyAllDriverLocation, notifyAllDriverStatus, notifyAllOrder, notifyOrderCreated } from './pages/map/messageBus';
import { LocalStorageKey } from './shared/enums';

class WebSocketService {
    static instance = null;
    static isConnected = false;

    socket = null;
    listeners = new Set();

    static getInstance() {
        if (!WebSocketService.instance) {
            WebSocketService.instance = new WebSocketService();
        }
        return WebSocketService.instance;
    }

    connect(url) {
        return new Promise((resolve, reject) => {
            if (this.socket) {
                console.warn('WebSocket already connected or connecting');
                resolve(this.socket.connected);
                return;
            }

            this.socket = new io(url, {
                transports: ['websocket'],
                reconnection: true,
                reconnectionAttempts: 30,
                reconnectionDelay: 2000,
            });

            this.socket.on('connect', () => {
                this.isConnected = true;

                const token = localStorage?.getItem(LocalStorageKey.TOKEN)?.replaceAll(`"`, "");

                if (token) {
                    this.send('authenticate', { token: token });
                    console.log('WebSocket authenticate');
                }
                resolve(true);
            });

            this.socket.on('receiveMessage', (data) => {
                notifyMessage(data);
            });

            this.socket.on('nearbyDriver', (data) => {
                notifyAllDriverLocation(data);
            });

            this.socket.on('driverStatus', (data) => {
                notifyAllDriverStatus(data);
            });

            this.socket.on('orderData', (data) => {
                notifyAllOrder(data);
            });

            this.socket.on('orderCreated', (data) => {
                notifyOrderCreated(data);
            });

            this.socket.on('disconnect', () => {
                console.log('WebSocket disconnected');
            });

            this.socket.on('error', (error) => {
                console.error('WebSocket error', error);
                reject(error);
            });
        });
    }

    send(event, data) {
        if (this.socket && this.socket.connected) {
            this.socket.emit(event, data);
        } else {
            console.warn('WebSocket not open. Message not sent.');
        }
    }

    close() {
        if (this.socket) {
            this.socket.close();
        }
    }
}

export default WebSocketService.getInstance();
